import {
    RaikoBaseCardContainer, RaikoGridOneColumn,
    RaikoLabel,
    RaikoSectionContainer, RaikoToggleOutlined,
    showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import RaikoBaseDialogContentContainer
    from "../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import React, {useEffect, useState} from "react";
import {ProductVariantService} from "../../../serverService/productVariantService/ProductVariantService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function ProductVariantEnabled({variantId}) {

    const [enabled, setEnabled] = useState(false);
    const service = new ProductVariantService();
    const loading = new LoadingHelper(useLoadingDispatcher());
    const [actionButtonLoading, setActionButtonLoading] = useState(false)

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getProductEnabledFromServer()
        }
    }, [variantId]);

    function getProductEnabledFromServer() {
        loading.show()
        service.getProductVariantEnabled(variantId)
            .then(response => {
                setEnabled(response.enabled)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateProductEnabled() {
        setActionButtonLoading(true)
        service.updateProductVariantEnabled(variantId,enabled)
            .then(response=>{
                if (enabled)
                    showSuccessMessage("انتشار محصول با موفقیت انجام شد.")
                else
                    showWarningMessage("وضعیت انتشار به پیش نویس تغییر پیدا کرد.")
            }).catch(reason => {
                showServerErrorMessage(reason)
        }).finally(_=>{
            setActionButtonLoading(false)
        })
    }


    return (
        <>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"وضعیت انتشار"}
                    subTitle={"تغییر وضعیت انتشار برای مشاهده ی نوع محصول توسط کاربران"}
                    hasHelperButton
                    helperTitle={"وضعیت انتشار"}
                    helperContent={
                        <RaikoBaseDialogContentContainer>
                            <RaikoLabel
                                text={"نوع محصول در ابتدا به صورت پیش نویس قرار خواهد گرفت و فقط توسط ادمین در پنل مدیریت قابل مشاهده و ویرایش خواهد بود."}/>
                            <RaikoLabel
                                text={"برای مشاهده ی نوع محصول توسط کاربران می بایست وضعیت انتشار را از روی پیش نویس به منتشر شده تغییر دهید."}/>
                            <RaikoLabel
                                text={"⚠️قبل از انتشار نوع محصول حتما از صحت اطلاعات و تکمیل بودن همه ی قسمت ها اطمینان حاصل نمایید!"}/>
                        </RaikoBaseDialogContentContainer>
                    }
                    hasActionButton
                    actionButtonLoadingState={actionButtonLoading}
                    actionButtonOnclick={handleUpdateProductEnabled}
                >
                    <RaikoGridOneColumn>
                        <RaikoToggleOutlined
                            checked={enabled}
                            setChecked={setEnabled}
                            labelText={"منتشر شده /  پیش نویس"}
                        />
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </>
    )
}